"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAppointmentRequestStruct = exports.UpdateAppointmentRequestAppointment = void 0;
const superstruct_1 = require("superstruct");
const types_1 = require("../types");
exports.UpdateAppointmentRequestAppointment = (0, superstruct_1.assign)((0, superstruct_1.omit)(types_1.AppointmentStruct, [
    'id',
    'startTime',
    'endTime',
    'queuedAt',
    'expiresAt',
    'createdAt',
    'invitedAt',
    'processedAt',
    'cancelledAt',
    'confirmationAt',
    'rejectedAt',
    'userId',
    'confirmation',
    'createdFrom',
]), (0, superstruct_1.type)({
    startTime: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    endTime: (0, superstruct_1.optional)((0, superstruct_1.string)()),
}));
exports.UpdateAppointmentRequestStruct = (0, superstruct_1.object)({
    placeId: (0, superstruct_1.string)(),
    appointmentId: (0, superstruct_1.string)(),
    appointment: (0, superstruct_1.object)(exports.UpdateAppointmentRequestAppointment.schema),
    counterId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
//# sourceMappingURL=UpdateAppointmentRequest.js.map